import React from 'react';

const Spinner = ({ text = 'Loading...' }) => (
  <div style={{
    height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: '#f5f5f5', fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
  }}>
    <div style={{ textAlign: 'center' }}>
      <div style={{
        width: 44, height: 44, border: '4px solid #eee', borderTopColor: '#4cbb4c',
        borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto 16px'
      }} />
      <p style={{ color: '#888', margin: 0 }}>{text}</p>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  </div>
);

export default Spinner;
